import React from "react";

import "./Page.scss";

const Page = (props: any) => {
  return <div className='PageContainer'>{props?.children || "props"}</div>;
};

export default Page;
